import { getApps, initializeApp, type FirebaseApp, type FirebaseOptions } from 'firebase/app';
import { GoogleAuthProvider, getAuth, type Auth } from 'firebase/auth';
import { getStorage, type FirebaseStorage } from 'firebase/storage';

export interface FirebaseClientServices {
  app: FirebaseApp;
  auth: Auth;
  googleProvider: GoogleAuthProvider;
  storage: FirebaseStorage;
}

/**
 * Creates (or reuses) the Firebase Web SDK app for a given config. Each web
 * app (customer-web, admin-web) calls this once at startup with its own
 * `import.meta.env`-sourced config.
 */
export function createFirebaseClient(config: FirebaseOptions): FirebaseClientServices {
  const app = getApps()[0] ?? initializeApp(config);
  const auth = getAuth(app);
  const googleProvider = new GoogleAuthProvider();
  const storage = getStorage(app);

  return { app, auth, googleProvider, storage };
}
